import { Observable } from 'rxjs';
import { isCordova } from 'utils/platform';

import { BrowserPermissionProvider } from './permissions/browser';
import { CordovaPermissionProvider } from './permissions/cordova';
import { PermissionProvider, Permissions } from './permissions/types';

export type {
  LocationPermissions,
  PermissionListener,
  PermissionProvider,
  Permissions,
} from './permissions/types';

const provider: PermissionProvider = isCordova()
  ? new CordovaPermissionProvider()
  : new BrowserPermissionProvider();

export const permissions$: Observable<Permissions> =
  new Observable<Permissions>((subscriber) => {
    const unsubscribe = provider.subscribe((permissions) => {
      subscriber.next(permissions);
    });
    return unsubscribe;
  }).shareReplay(1);

export function requestLocationBackgroundPermission(): Promise<boolean> {
  return provider.requestLocationBackgroundPermission();
}

export function requestLocationInUsePermission(): Promise<boolean> {
  return provider.requestLocationInUsePermission();
}

export function requestHighAccuracyLocationPermission(): Promise<boolean> {
  return provider.requestHighAccuracyLocationPermission();
}

export function permissions(): Promise<Permissions> {
  return provider.refreshPermissions();
}

export function askForLocationPermissionsAfterDenial(): Promise<boolean> {
  return provider.askForLocationPermissionsAfterDenial();
}
